'use client';

/**
 * ca_preview only: the campsite page's community and listing actions, which
 * were three separate sidebar panels (Share your experience, Own this
 * campsite, Explore regions), as one ruled list in the main column, in the
 * store's link-list style.
 */
import React from 'react';
import Link from 'next/link';
import { withBase } from '../../lib/brand';
import { useCaPreview } from '../../lib/caPreview';
import ClaimSiteButton from '../ClaimSiteButton';
import type { Entity, Region } from '../../types';

const regionSlug = (name: string) => name.toLowerCase().replace(/&/g, 'and').replace(/ +/g, '-').replace(/--+/g, '-');

const Arrow = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);

export default function CampsiteMore({ entity, regions, isAccom }: { entity: Entity; regions: Region[]; isAccom?: boolean }) {
  const preview = useCaPreview();
  if (!preview) return null;
  return (
    <section className="ca-more" aria-labelledby="ca-more-h">
      <h2 id="ca-more-h" className="ca-more__h">Been here?</h2>
      <p className="ca-more__lede">Photos and reviews from people who have stayed help the next camper decide.</p>
      <ul className="ca-more__list" role="list">
        <li>
          <button type="button" onClick={() => window.dispatchEvent(new CustomEvent('open-photo-upload'))}>
            <span>Add a photo</span>
            <Arrow />
          </button>
        </li>
        <li>
          <button type="button" onClick={() => window.dispatchEvent(new CustomEvent('open-review-form'))}>
            <span>Write a review</span>
            <Arrow />
          </button>
        </li>
        <li>
          <button type="button" onClick={() => window.dispatchEvent(new CustomEvent('trip-chat-open'))}>
            <span>Ask our camping assistant about this place</span>
            <Arrow />
          </button>
        </li>
        {regions.slice(0, 3).map((r) => (
          <li key={r.id}>
            <Link href={withBase(`/regions/${regionSlug(r.name)}`)}>
              <span>
                More places to stay in {r.name}
              </span>
              <Arrow />
            </Link>
          </li>
        ))}
        <li className="ca-more__claim">
          <span className="ca-more__q">Own or run this {isAccom ? 'property' : 'campsite'}?</span>
          <ClaimSiteButton entity={entity} className="ca-more__claimbtn" />
        </li>
      </ul>
    </section>
  );
}
